import React from "react"
import {useFormik} from "formik";
import * as yup from "yup";
import {useTranslation} from "react-i18next";

// react-router-dom components
import {Link, useSearchParams} from "react-router-dom";

import {usePasswordResetMutation} from "../query";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "materialDashboard/components/MDBox";
import MDTypography from "materialDashboard/components/MDTypography";
import MDLoadingButton from "../../../components/MDLoadingButton";
import PasswordInput from "../../../components/inputs/PasswordInput";


function PasswordReset() {
    const {t} = useTranslation(["auth", "validation"])
    const {mutateAsync, isLoading, isError} = usePasswordResetMutation();

    // Get the reset token from the url
    const [searchParams] = useSearchParams();
    const resetToken = searchParams.get("token");

    const formik = useFormik({
            initialValues: {
                password: '',
                passwordConfirmation: '',
            }, validationSchema: yup.object({
                password: yup
                    .string()
                    .required(t('validation:required')),
                passwordConfirmation: yup
                    .string()
                    .required(t('validation:required'))
                    .oneOf([yup.ref('password'), null], t('validation:passwordsMustMatch'))
            }), onSubmit: async (values) => {
                await mutateAsync({token: resetToken, new_password: values.password})
            }
        }
    )

    return (
        <Card>
            <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center"
            >
                <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                    {t("resetPassword.title")}
                </MDTypography>
            </MDBox>

            <MDBox pt={4} pb={3} px={3}>
                {
                    isError && <MDTypography color="error" align="center" variant="body2">
                        {t('resetPassword.errorMsg')}
                    </MDTypography>
                }
                <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
                    <MDBox mb={2}>
                        <PasswordInput label={t("resetPassword.password")}
                                       fullWidth
                                       name="password"
                                       value={formik.values.password}
                                       onChange={formik.handleChange}
                                       error={formik.touched.password && Boolean(formik.errors.password)}
                                       helperText={formik.touched.password && formik.errors.password}/>
                    </MDBox>
                    <MDBox mb={2}>
                        <PasswordInput label={t("resetPassword.passwordConfirmation")}
                                       fullWidth
                                       name="passwordConfirmation"
                                       value={formik.values.passwordConfirmation}
                                       onChange={formik.handleChange}
                                       error={formik.touched.passwordConfirmation && Boolean(formik.errors.passwordConfirmation)}
                                       helperText={formik.touched.passwordConfirmation && formik.errors.passwordConfirmation}/>
                    </MDBox>

                    <MDBox mt={4} mb={1}>
                        <MDLoadingButton variant="gradient"
                                         color="info"
                                         fullWidth
                                         loading={isLoading}
                                         type="sumbit">
                            {t("resetPassword.submit")}
                        </MDLoadingButton>
                    </MDBox>

                    <MDBox mt={3} mb={1} textAlign="center">
                        <MDTypography
                            component={Link}
                            to="/auth/sign-in"
                            variant="button"
                            color="info"
                            fontWeight="medium"
                            textGradient
                        >
                            {t("resetPassword.back")}
                        </MDTypography>
                    </MDBox>
                </MDBox>
            </MDBox>
        </Card>
    );
}

export default PasswordReset;
